<template>
  <div class="delivery_oplata">
    <div class="do_title">
      {{ text('screen_form_delivery_method') }}
    </div>
    <div class="delivery_oplata_list">
      <label
        :class="{ dos_block_with_children:
        deliveryService.types.length !== 0 ||
        isVisibleRussianPostTemplate(deliveryService) ||
        isVisiblePekTemplate(deliveryService) ||
        (typeof deliveryService.delivery_methods[0] === 'object' && deliveryService.delivery_methods[0].hasOwnProperty('name') && deliveryService.delivery_methods[0].name === 'СДЭК' && $store.getters.cdekInfo.tariffs && $store.getters.cdekInfo.tariffs.length > 0) }"
        class="dol_block"
        v-for="deliveryService in deliveryServices"
        :key="deliveryService.id"
        
      >
        <input
          :checked="selected && deliveryService.id === selected.id"
          :value="deliveryService.id"
          name="delivery_service"
          type="radio"
          :disabled="isDisabledDeliveryService(deliveryService)"
          v-on:change="update(deliveryService)"
        />
        <div class="dol_content" :class="{'dol_content-special': isVisibleSpecialDeliveryLoader(deliveryService)}">
          <div v-if="isVisibleSpecialDeliveryLoader(deliveryService)" class="lds-ring"><div></div><div></div><div></div><div></div></div>
          <div class="dol_inner">
            <div class="dol_name">
              {{ deliveryService.name }}
              <span
                class="dos_price"
                :class="{'ios-font': $store.getters.checkIos}"
                v-if="
                  deliveryService.types.length === 0 && deliveryService.price
                "
              >{{ $options.filters.toCurrency(deliveryService.price) }}</span
              >
            </div>
            <div class="dol_dop">
              <div class="dol_dop_text">{{ deliveryService.description }}</div>
            </div>
          </div>
        </div>

        <template v-if="deliveryService.types.length !== 0">
          <transition-group name="list">
            <label
              :key="deliveryService.id + '_' + deliveryServiceType.id"
              class="dol_block dos_block"
              v-for="deliveryServiceType in deliveryService.types"
              v-show="selected && deliveryService.id === selected.id"
            >
              <input
                :checked="
                  selectedType && deliveryServiceType.id === selectedType.id
                "
                :value="deliveryServiceType.id"
                name="delivery_service_type"
                type="radio"
                v-on:change="updateType(deliveryServiceType)"
              />
              <div class="dol_content dos_content">
                <div class="dol_inner">
                  <div class="dol_name">
                    {{ deliveryServiceType.name }}
                    <span class="dos_price" v-if="deliveryServiceType.price" :class="{'ios-font': $store.getters.checkIos}">
                      {{ $options.filters.toCurrency(deliveryServiceType.price) }}
                    </span>
                  </div>
                  <div
                    class="dol_dop"
                    style="visibility: visible; opacity: 1; height: auto"
                  >
                    <div class="dol_dop_text">
                      {{ deliveryServiceType.description }}
                    </div>
                  </div>
                </div>
              </div>
            </label>
          </transition-group>
        </template>

        <template v-if="isVisibleRussianPostTemplate(deliveryService)">
          <transition-group name="list">
            <label
              :key="'russianPostItem' + '_' + russianPostItem.id"
              class="dol_block dos_block"
              v-for="russianPostItem in $store.getters.russianPostInfo"
              v-show="selected && deliveryService.id === selected.id"
            >
              <input
                :checked="
                  selectedType && russianPostItem.id === selectedType.id
                "
                :value="russianPostItem.id"
                name="delivery_service_type"
                type="radio"
                v-on:change="updateDeliveryMethodCalc(russianPostItem)"
              />
              <div class="dol_content dos_content">
                <div class="dol_inner">
                  <div class="dol_name">
                    {{ russianPostItem.name }}
                    <span class="dos_price" v-if="russianPostItem.value" :class="{'ios-font': $store.getters.checkIos}">
                      {{ $options.filters.toCurrency(Number(russianPostItem.value)) }}
                    </span>
                  </div>
                </div>
              </div>
            </label>
          </transition-group>
        </template>

        <template v-if="isVisiblePekTemplate(deliveryService)">
          <transition-group name="list">
            <label
              :key="'pekItem' + '_' + pekItem.id"
              class="dol_block dos_block"
              v-for="pekItem in $store.getters.pekInfo"
              v-show="selected && deliveryService.id === selected.id"
            >
              <input
                :checked="
                  selectedType && pekItem.id === selectedType.id
                "
                :value="pekItem.id"
                name="delivery_service_type"
                type="radio"
                v-on:change="updateDeliveryMethodCalc(pekItem)"
              />
              <div class="dol_content dos_content">
                <div class="dol_inner">
                  <div class="dol_name">
                    {{ pekItem.name }}
                    <span class="dos_price" v-if="pekItem.total" :class="{'ios-font': $store.getters.checkIos}">
                      {{ $options.filters.toCurrency(Number(pekItem.total)) }}
                    </span>
                  </div>
                </div>
              </div>
            </label>
          </transition-group>
        </template>

        <template v-if="isVisibleCdekTemplate(deliveryService)">
          <transition-group name="list">
            <label
              class="dol_block dos_block"
              :key="'cdekButton-' + selectedCdekTarrif.id"
              v-show="selected && deliveryService.id === selected.id && selectedCdekTarrif.is_pickup"
            >
              <div class="dol_content dos_content cdek_label">
                <div class="dol_inner">
                  <div class="dol_name" @click="cdekWidgetHandler">
                    {{$store.getters.deliveryMethodPvzData ? $store.getters.deliveryMethodPvzData : 'Выбрать пункт самовывоза'}}
                  </div>
                </div>
              </div>
            </label>
            <label
              :key="'cdekItem' + '_' + cdekItem.id"
              class="dol_block dos_block"
              v-for="cdekItem in $store.getters.cdekInfo.tariffs"
              v-show="selected && deliveryService.id === selected.id"
            >
              <input
                :checked="
                  selectedType && cdekItem.id === selectedType.id
                "
                :value="cdekItem.id"
                name="delivery_service_type"
                type="radio"
                v-on:change="updateDeliveryMethodCalcCdek(cdekItem)"
              />
              <div class="dol_content dos_content">
                <div class="dol_inner">
                  <div class="dol_name">
                    {{ cdekItem.name }}
                    <span class="dos_price" v-if="cdekItem.value" :class="{'ios-font': $store.getters.checkIos}">
                      {{ $options.filters.toCurrency(Number(cdekItem.value)) }}
                    </span>
                  </div>
                </div>
              </div>
            </label>
          </transition-group>
        </template>

      </label>
    </div>

    <transition name="fade">
      <div :key="'compact_selector_dark'" class="pu_dark" v-show="isVisibleCdekMap"></div>
    </transition>
    <transition name="slide">
      <div :key="'compact_selector'" class="pu_bottom popup_click_hide" v-show="isVisibleCdekMap">
        <div class="pu_bottom_scroll">
          <div @click="cdekWidgetHandler" class="pu_b_close"></div>
          <div class="pu_bottom_inner ">
            <div class="pu_select pu_select__cdek" style="display: block">
              <div id="forpvz" style="height:400px;"></div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { SET_SPECIAL_DELIVERY_METHOD, SET_DELIVERY_TO_CITY, SET_DELIVERY_METHOD_PVZ_ID, SET_DELIVERY_METHOD_PVZ_DATA } from '@/store/mutations.type'

  export default {
    name: 'DeliveryServices',
    props: {
      deliveryServices: Array,
      selected: Object,
      selectedType: Object
    },
    data() {
      return {
        cdekWidget: null,
        isVisibleCdekMap: false,
        selectedCdekTarrif: {}
      }
    },
    mounted() {
      this.deliveryServices.forEach(item => {
        if (this.isVisibleCdekTemplate(item)) {
          let cdekScript = document.createElement('script')
          cdekScript.setAttribute('src', 'https://www.cdek.ru/website/edostavka/template/js/widjet.js')
          document.head.appendChild(cdekScript)
          cdekScript.onload = () => {
            this.cdekWidget = new ISDEKWidjet({
              defaultCity: this.$store.getters.deliveryToCity ? this.$store.getters.deliveryToCity : 'auto',
              cityFrom: this.$store.getters.deliveryFromCity,
              link: 'forpvz',
              path: 'https://widget.cdek.ru/widget/scripts/',
              hidedress: true,
              hidedelt: true,
              onChoose: this.onChoose
            });

            this.$store.subscribe(mutation => {
              if (mutation.type === SET_DELIVERY_TO_CITY) {
                this.cdekWidget.city.set(this.$store.getters.deliveryToCity)
              }
            })
          }
        }
      })
    },
    methods: {
      isVisibleSpecialDeliveryLoader(deliveryService) {
        return (
          typeof deliveryService.delivery_methods[0] === 'object'
          && deliveryService.delivery_methods[0].hasOwnProperty('name')
          && deliveryService.delivery_methods[0].name === 'СДЭК'
          && this.$store.getters.cdekInfo.length === 0)
          || (typeof deliveryService.delivery_methods[0] === 'object'
            && deliveryService.delivery_methods[0].hasOwnProperty('name')
            && deliveryService.delivery_methods[0].name === 'Почта России'
            && this.$store.getters.russianPostInfo.length === 0)
          || (typeof deliveryService.delivery_methods[0] === 'object'
            && deliveryService.delivery_methods[0].hasOwnProperty('name')
            && deliveryService.delivery_methods[0].name === 'ПЭК'
            && Object.keys(this.$store.getters.pekInfo).length === 0)
      },
      cdekWidgetHandler() {
        this.isVisibleCdekMap = !this.isVisibleCdekMap
      },
      onChoose(wat) {
        this.$store.commit(SET_DELIVERY_METHOD_PVZ_ID, wat.id)
        this.$store.commit(SET_DELIVERY_METHOD_PVZ_DATA, wat.PVZ.Address)
        this.cdekWidgetHandler()
      },
      isVisibleRussianPostTemplate(deliveryService) {
        return typeof deliveryService.delivery_methods[0] === 'object'
          &&  deliveryService.delivery_methods[0].hasOwnProperty('name')
          && deliveryService.delivery_methods[0].name === 'Почта России'
          && this.$store.getters.russianPostInfo.length > 0
      },
      isVisiblePekTemplate(deliveryService) {
        return typeof deliveryService.delivery_methods[0] === 'object'
          &&  deliveryService.delivery_methods[0].hasOwnProperty('name')
          && deliveryService.delivery_methods[0].name === 'ПЭК'
          && Object.keys(this.$store.getters.pekInfo).length > 0
      },
      isVisibleCdekTemplate(deliveryService) {
        return typeof deliveryService.delivery_methods[0] === 'object'
          && deliveryService.delivery_methods[0].hasOwnProperty('name')
          && deliveryService.delivery_methods[0].name === 'СДЭК'
      },
      isDisabledDeliveryService(deliveryService) {
        let CDEK = typeof deliveryService.delivery_methods[0] === 'object' && deliveryService.delivery_methods[0].hasOwnProperty('name') && deliveryService.delivery_methods[0].name === 'СДЭК' ? deliveryService : null
        let PR = typeof deliveryService.delivery_methods[0] === 'object' && deliveryService.delivery_methods[0].hasOwnProperty('name') && deliveryService.delivery_methods[0].name === 'Почта России' ? deliveryService : null
        let PEK = typeof deliveryService.delivery_methods[0] === 'object' && deliveryService.delivery_methods[0].hasOwnProperty('name') && deliveryService.delivery_methods[0].name === 'ПЭК' ? deliveryService : null

        if (PR && this.$store.getters.russianPostInfo.length === 0) {
          return true
        }
        if (PEK && Object.keys(this.$store.getters.pekInfo).length === 0) {
          return true
        }
        if (CDEK && this.$store.getters.cdekInfo.length === 0) {
          return true
        }
        return false
      },
      update(deliveryService) {
        this.$emit(
          'update:selectedType',
          deliveryService.types.length === 0 ? null : deliveryService.types[0]
        )
        this.$emit('update:selected', deliveryService)
      },
      updateType(deliveryServiceType) {
        this.$emit('update:selectedType', deliveryServiceType)
      },
      updateDeliveryMethodCalcCdek(deliveryMethodCalc) {
        this.selectedCdekTarrif = deliveryMethodCalc
        this.$store.commit(SET_SPECIAL_DELIVERY_METHOD, deliveryMethodCalc)
        this.$emit('update:selectedDeliveryMethodCalc', deliveryMethodCalc.id)
      },
      updateDeliveryMethodCalc(deliveryMethodCalc) {
        this.$store.commit(SET_SPECIAL_DELIVERY_METHOD, deliveryMethodCalc)
        this.$emit('update:selectedDeliveryMethodCalc', deliveryMethodCalc.id)
      },
      // checkPekPrices() {
      //   const pekList = Object.values(this.$store.getters.pekInfo);

      //   for (let index = 0; index < pekList.length; index++) {
      //     if (pekList[index].total > 0) {
      //       return true;
      //     }
      //   }
        
      //   return false;
      // }
    }
  }
</script>

<style scoped>
  .pu_select__cdek {
    padding-top: 20px;
    margin-bottom: 0 !important;
    width: auto !important;
  }
  .cdek_label:after {
    display: none !important;
  }
  .cdek_label:before {
    display: none !important;
  }
  .lds-ring {
    display: inline-block;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
  }
  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 24px;
    height: 24px;
    border: 4px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .dol_content-special:after, .dol_content-special:before {
    display: none;
  }
</style>
